import { render, staticRenderFns } from "./editArticleTag.vue?vue&type=template&id=03e2e4c4&scoped=true&"
import script from "./editArticleTag.vue?vue&type=script&lang=ts&"
export * from "./editArticleTag.vue?vue&type=script&lang=ts&"
import style0 from "./editArticleTag.vue?vue&type=style&index=0&id=03e2e4c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2e4c4",
  null
  
)

export default component.exports